import { useEffect } from 'react';

export const usePageTitle = (title) => {
  useEffect(() => {
    const fullTitle = title
      ? `${title} — Rishidev Foundation`
      : 'Rishidev Foundation — Timeless Wisdom of Sanatana Dharma';
    document.title = fullTitle;
  }, [title]);
};
